import { FC, ReactElement } from 'react'
import clsx from 'clsx'

import TagThemes from './themes'

import styles from './basic-tag.module.scss'

interface IBasicTag {
  themeColor?: TagThemes
  uppercase?: boolean
  children: string | ReactElement
}

const BasicTag: FC<IBasicTag> = ({ themeColor = TagThemes.BLACK, uppercase = true, children }) => {
  const defineTheme = clsx(styles.tag, styles[themeColor], {
    [styles.uppercase]: uppercase,
  })

  return <div className={defineTheme}>{children}</div>
}

export default BasicTag
